import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUserList } from "services/apiService";

export const fetchSuggestions = createAsyncThunk(
  "fetchSuggestions",
  async () => {
    try {
      const getUserListRes = await getUserList();
      // console.log("here1", getFeedRes);
      return getUserListRes.data.slice(0, 5);
    } catch (error) {
      console.log("fetchSuggestionsReducerError", error);
    }
  }
);

const initialState = {
  userAppNotificationCount: 0,
  userAppSuggestions: [],
  suggestionIsLoading: false,
};

const suggAndNotificationSlice = createSlice({
  name: "userSugg&Notifications",
  initialState: initialState,
  reducers: {
    getUserAppNotificationCount(state, action) {
      state.userAppNotificationCount = action.payload;
    },
    getUserAppSuggestions(state, action) {
      state.userAppSuggestions = action.payload;
      state.suggestionIsLoading = false;
    },
    suggAndNotiReducerReset() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuggestions.pending, (state) => {
        state.suggestionIsLoading = true;
      })
      .addCase(fetchSuggestions.fulfilled, (state, action) => {
        state.userAppSuggestions = action.payload;

        state.suggestionIsLoading = false;
      });
  },
});

export const {
  getUserAppNotificationCount,
  getUserAppSuggestions,
  suggAndNotiReducerReset,
} = suggAndNotificationSlice.actions;
export default suggAndNotificationSlice.reducer;
